module.exports = __webpack_public_path__ + "img/pdf.e6d3af1a.png";